import {
    CHANGE_LOGIN_DATA,
    LOGIN_ERROR,
    LOGIN_FROM_TOKEN_ERROR,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGOUT,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.auth.login, action = {type: ''}) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    password: '',
                },
                loading: false,
            };
        case LOGIN_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        case LOGIN_FROM_TOKEN_ERROR:
            return {
                ...state,
                errorFromToken: true,
                loading: false,
            };
        case LOGIN_START:
            return {
                ...state,
                error: false,
                errorFromToken: false,
                loading: true,
            };
        case CHANGE_LOGIN_DATA:
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.payload.field]: action.payload.data,
                },
            };
        case LOGOUT:
            return initialState.auth.login;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/authReducer/loginReducer.js